import React, { } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';
import '../../../../../../scss/integration.scss';

/**
 *
 */
function UnicommerceStepInfo({ step, loading, setStep }) {
  /**
   *
   * @return {JSX.Element}
   */

  return (
    <div className="integration-step-info-wrapper">
      {loading
        ? (
          <div className="unicommerce-step-info-loading__wrapper">
            {[1, 2, 3, 4]?.map((item) => (
              <div key={item} className="unicommerce-step-info-loading-line">
                <div className="loadingBlock unicommerce-step-info-loading-dot" />
                <div className="loadingBlock unicommerce-step-info-loading-text" />
              </div>
            ))}
          </div>

        )

        : (
          <div style={{ marginTop: '20px' }}>
            <div className="integration-step-info-status-wrapper" onClick={() => setStep(1)}>
              <div className={`dot  ${ step === 1 ? 'dot-blue' : 'dot-green'} `} />
              <div className="integration-step-info-status-heading-active ">&nbsp;Account Login</div>
            </div>
            <div className="integration-step-info-status-wrapper" onClick={() => step > 2 && setStep(2)}>
              <div className={`dot dot-grey ${ step === 2 ? 'dot-blue' : step > 2 && 'dot-green' }`} />
              <div className="integration-step-info-status-heading-active">&nbsp;Map Locations</div>
            </div>
            <div className="integration-step-info-status-wrapper" onClick={() => step > 3 && setStep(3)}>
              <div className={`dot dot-grey ${ step === 3 ? 'dot-blue' : step > 3 && 'dot-green' }`} />
              <div className="integration-step-info-status-heading-active">&nbsp;Sync Inventory</div>
            </div>
            <div className="integration-step-info-status-wrapper" onClick={() => step > 4 && setStep(4)}>
              <div className={`dot dot-grey ${ step === 4 ? 'dot-blue' : step > 4 && 'dot-green' }`} />
              <div className="integration-step-info-status-heading-active">&nbsp;Configurations</div>
            </div>
            <div className="integration-step-info-status-wrapper" onClick={() => step > 5 && setStep(5)}>
              <div className={`dot dot-grey ${ step === 4 ? 'dot-blue' : step > 5 && 'dot-green' }`} />
              <div className="integration-step-info-status-heading-active">&nbsp;Finish</div>
            </div>

          </div>
        ) }

    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({

});
UnicommerceStepInfo.propTypes = {
  step: PropTypes.any,
  loading: PropTypes.bool,
  setStep: PropTypes.func,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnicommerceStepInfo));
